import { render, staticRenderFns } from "./Sanction.vue?vue&type=template&id=3a5176ea&scoped=true&"
import script from "./Sanction.vue?vue&type=script&lang=js&"
export * from "./Sanction.vue?vue&type=script&lang=js&"
import style0 from "./Sanction.vue?vue&type=style&index=0&id=3a5176ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5176ea",
  null
  
)

export default component.exports